const doc = [({"en":({"js":({"admin":({"users":({"edit":({"add_new_user":"Add new user", "edit_user":"Edit user: %{name}", "the_user_was_saved":"The user was saved"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;